import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { WcGridComponent } from '../../components/wc-grid/wc-grid.component';

@Component({
  selector: 'global-users',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './global-users.component.html',
  styleUrl: './global-users.component.css'
})
export class GlobalUsersComponent {

  @ViewChild('globalGrid') grid?: WcGridComponent;

  reload(): void {
    this.grid?.reload(1);
  }
}
